function getVehicleId () {
  return window.localStorage.getItem('selectedVehicle')
}

function setVehicleId (vehicleId) {
  window.localStorage.setItem('selectedVehicle', vehicleId)
}

function removeVehicleId () {
  window.localStorage.removeItem('selectedVehicle')
}

function bannerClosed () {
  const closedBannerDateStr = window.localStorage.getItem('closedBannerDate')

  if (!closedBannerDateStr) {
    return false
  }

  const closedBannerDate = new Date(closedBannerDateStr)
  const showBannerAgainDate = new Date()
  showBannerAgainDate.setDate(showBannerAgainDate.getDate() - 30)

  return closedBannerDate > showBannerAgainDate
}

function setBannerClosed () {
  window.localStorage.setItem('closedBannerDate', new Date().toISOString())
}

export default {
  getVehicleId,
  setVehicleId,
  removeVehicleId,
  bannerClosed,
  setBannerClosed
}
